import React from "react";
import { Pressable } from "react-native";
import { Colors, LoaderScreen, View } from "react-native-ui-lib";

export interface LoadingListItemRendererProps {
  onAction?: () => void;
}

export function LoadingListItemRenderer({
  onAction,
}: LoadingListItemRendererProps) {
  const Wrapper = onAction ? Pressable : React.Fragment;

  const wrapperProps = onAction ? { onPress: onAction } : {};

  return (
    <Wrapper {...wrapperProps}>
      <View
        flex
        row
        style={{
          alignItems: "center",
          justifyContent: "flex-start",
        }}
        height={70}
      >
        <LoaderScreen message="Loading..." color={Colors.grey40} />
      </View>
    </Wrapper>
  );
}
